export class PasswordRecoveryRequest {
    login: string;
    NewPassword: string;
    Channel: string;
    constructor(login: string, NewPassword: string, Channel: string) {
        this.login = login;
        this.NewPassword = NewPassword;
        this.Channel = Channel;
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/models/requests/password-recovery-request.ts